import React from 'react';
import { Link } from 'react-router-dom';
import './ManuscriptDetailCard.css';

const ManuscriptDetailCard = ({ metadata, onClose }) => {
  if (!metadata) return null;

  return (
    <div className="manuscript-detail-card">
      <div className="card-header">
        <h3 className="card-title-ar" dir="rtl">{metadata.title_ar}</h3>
        <h4 className="card-title-lat">{metadata.title_lat}</h4>
        <button className="close-button" onClick={onClose}>×</button>
      </div>
      
      <div className="card-body">
        <div className="detail-row">
          <span className="detail-label">Author:</span>
          <span className="detail-value">
            <div dir="ltr" className="arabic-text">{metadata.author_ar}</div>
            <div className="latin-text">{metadata.author_lat} (d. {metadata.date})</div>
          </span>
        </div>
        
        <div className="detail-row">
          <span className="detail-label">Library:</span>
          <span className="detail-value">{metadata.library}, {metadata.collection_name}</span>
        </div>
        
        <div className="detail-row">
          <span className="detail-label">Folios:</span>
          <span className="detail-value">{metadata.start_folio}-{metadata.end_folio}</span>
        </div>
        
        <div className="detail-row">
          <span className="detail-label">Lang:</span>
          <span className="detail-value">{metadata.language}</span>
        </div>
        
        <div className="detail-description">
          <p>{metadata.description}</p>
        </div>
      </div>
      
      <div className="card-footer">
        <Link to={`/manuscript/${metadata.manuscript_id}`} className="detail-link">
          View Full Details
        </Link>
      </div>
    </div>
  );
};

export default ManuscriptDetailCard;